import React, { Component, Fragment } from 'react'

import { COOKIES } from 'utils/constants'
import {
  cleanArray,
  sortArrayAlphabeticallyByObjKey,
  reorderFilter,
  setEventToLazyDispatch,
  cleanString,
} from 'utils/utils'
import { withCookieNotice } from '@/store/context/cookie-notice-context'
import { cookieCategoryIsActive } from '@/modern/utils/cookies'

import Slide from 'components/Slide'

import FilterContainer from './FilterContainer'
import FilterGroup from './FilterGroup'

class DynamicFilterGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filters: {
        car: [],
        bike: [],
      },
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(this.props.activeFilters) !=
        JSON.stringify(this.state.filters[this.props.vehicleType]) &&
      JSON.stringify(this.props.activeFilters) !=
        JSON.stringify(prevState.filters[this.props.vehicleType])
    ) {
      this.setInitialFilters()
    }
    if (
      JSON.stringify(this.state.filters[this.props.vehicleType]) !=
      JSON.stringify(prevState.filters[this.props.vehicleType])
    ) {
      this.props.callBack(
        this.props.filterGroupName,
        this.state.filters[this.props.vehicleType]
      )
    }
    if (typeof document !== 'undefined') {
      if (this.props.slideLeftOpen) {
        document.querySelector('html').classList.add('no-scrolling-touch')
        document.querySelector('body').classList.add('no-scrolling-touch')
      } else {
        document.querySelector('html').classList.remove('no-scrolling-touch')
        document.querySelector('body').classList.remove('no-scrolling-touch')
      }
    }
  }

  setInitialFilters() {
    const { filters } = this.state
    const type = this.props.vehicleType
    filters[type] = this.props.activeFilters

    this.setState({ filters }, () => {
      this.props.callBack(this.props.filterGroupName, this.state.filters[type])
    })
  }

  setFilters() {
    const { filters } = this.state
    const type = this.props.vehicleType
    filters[type] = this.props.activeFilters

    this.setState({ filters }, () => {
      this.props.callBack(this.props.filterGroupName, this.state.filters[type])
    })
  }

  handleOpen(state) {
    this.setState({
      slideLeftOpen: state || !this.state.slideLeftOpen,
    })
  }

  handleInvalid() {
    const filters = []
    const type = this.props.vehicleType
    if (
      this.props.filtersSource &&
      Array.isArray(this.props.filtersSource) &&
      this.props.filtersSource.length
    ) {
      const filtersSource = Object.keys(this.props.filtersSource).map(index => {
        return this.props.filtersSource[index].name
      })
      const filtersState = this.state.filters[type]
      Object.keys(filtersState).forEach(index => {
        filtersSource.includes(filtersState[index]) && filters.push(filtersState[index])
      })
      if (JSON.stringify(filtersState) != JSON.stringify(filters)) {
      }
    }
    if (JSON.stringify(this.state.filters[type]) != JSON.stringify(filters)) {
      this.setState({ filters: { ...this.state.filters, [type]: filters } })
    }
  }

  handleChange(value) {
    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.TRACKING_FROM
    )

    const type = this.props.vehicleType
    const filters = JSON.parse(JSON.stringify(this.state.filters))
    if (!filters[type].includes(value)) {
      if (value === 'Pessoa Física') this.props.hideCarDeliveryFilter(true)
      filters[type].push(value)
      filters[type] = cleanArray(filters[type])
    } else {
      if (value === 'Pessoa Física') this.props.hideCarDeliveryFilter(false)
      const index = filters[type].indexOf(value)
      delete filters[type][index]
      filters[type] = cleanArray(filters[type])
    }
    this.setState({ filters })

    if (isCookieCategoryActive) {
      setEventToLazyDispatch('filtroRealizado')
    }
  }

  renderCheckbox(value, prefix) {
    const firstLetter = value.substring(0, 1).toUpperCase()
    const { dataQA } = this.props
    const dataQASeparator = prefix === 'modal' ? '_item_' : '_'
    const labelDataQA = dataQA
      ? `${dataQA}${dataQASeparator}${cleanString(value, {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        })}`
      : undefined

    const newValue =
      value.indexOf(' ') > 0
        ? firstLetter +
          value.substring(1, value.indexOf(' ')) +
          value.substring(value.indexOf(' ')).toLowerCase()
        : firstLetter + value.substring(1)
    return (
      <div
        className="Form__InputRow"
        key={`${
          (prefix || '') + this.props.filterGroupName
        }dynamiccheck${value}`}
      >
        <label data-qa={labelDataQA} className="Checkbox">
          <input
            type="checkbox"
            name={value}
            id={value}
            onChange={this.handleChange.bind(this, value)}
            checked={this.state.filters[this.props.vehicleType].includes(value)}
            className="Form__TextInput"
          />
          {newValue}
        </label>
      </div>
    )
  }

  renderBack() {
    const { title } = this.props
    const GoBackDataQa = `filter_go_back_${cleanString(title, {
      toLowerCase: 1,
      removeAccents: 1,
      removeDots: 1,
      slugify: 1,
    })}`

    return (
      <div
        data-qa={GoBackDataQa}
        className="Filters__back"
        onClick={
          this.props.handleOpen ? () => this.props.handleOpen(false) : undefined
        }
      />
    )
  }

  renderSlide() {
    return (
      <Slide isOpen={this.props.slideLeftOpen} position="Left">
        <FilterContainer title={this.props.title}>
          {this.renderList(0, 'modal', false)}
          {this.renderBack()}
        </FilterContainer>
      </Slide>
    )
  }

  renderList(limit, prefix, showMore) {
    const elements = []
    const selectedElements = []
    if (this.props.filtersSource && this.props.vehicleType) {
      let filters = this.props.filtersSource ? this.props.filtersSource : []
      const selectedFilters = this.state.filters[this.props.vehicleType]
      const allFiltersArr = []
      const forceSelected = []
      for (let i = 0; i < filters.length; i++) {
        allFiltersArr.push(filters[i].name)
      }
      for (let i = 0; i < selectedFilters.length; i++) {
        if (!allFiltersArr.includes(selectedFilters[i])) {
          forceSelected.push(selectedFilters[i])
        }
      }
      if (forceSelected.length) {
        for (let i = 0; i < forceSelected.length; i++) {
          filters.push({ name: forceSelected[i], Count: 0 })
        }
      }
      if (this.props.title === 'Ofertas') {
        const sorted = sortArrayAlphabeticallyByObjKey(filters, 'name')
        filters = reorderFilter(sorted, ['megafeirao', 'blackfeirao'])
      } else {
        filters = sortArrayAlphabeticallyByObjKey(filters, 'name')
      }

      let selectedCount = 0
      Object.keys(filters).forEach(index => {
        index = parseInt(index)
        if (typeof filters[index].name === 'string') {
          selectedFilters.includes(filters[index].name) && (selectedCount += 1)
          if (
            showMore &&
            selectedFilters.includes(filters[index].name) &&
            filters.length > limit &&
            (index >= limit ||
              selectedFilters.length >= limit ||
              index + (selectedFilters.length - selectedCount) >= limit)
          ) {
            selectedElements.push({
              name: filters[index].Name,
              checkbox: this.renderCheckbox(filters[index].name, prefix),
            })
          } else {
            elements.push({
              name: filters[index].Name,
              checkbox: this.renderCheckbox(filters[index].name, prefix),
            })
          }
        }
      })
    }
    const elementsReturn = selectedElements
      .concat(elements)
      .map(item => item.checkbox)
    if (showMore) {
      if (elementsReturn.length > Math.max(limit, selectedElements.length)) {
        if (!this.state.showMore) this.setState({ showMore: true })
        elementsReturn.splice(Math.max(limit, selectedElements.length))
      } else if (this.state.showMore) {
        this.setState({ showMore: false })
      }
    }
    return (
      <FilterGroup title={this.props.title}>
        {elementsReturn}
        {showMore && this.state.showMore ? this.renderShowMore() : ''}
      </FilterGroup>
    )
  }

  renderShowMore() {
    if (this.props.handleOpen) {
      const { text } = this.props
      const seeAllDataQA = text
        ? cleanString(text, {
            toLowerCase: 1,
            removeAccents: 1,
            removeDots: 1,
            slugify: 1,
          })
        : undefined
      return (
        <div
          data-qa={seeAllDataQA}
          onClick={() => {
            this.props.handleOpen(true)
            this.handleOpen(true)
          }}
          className="Filters__line Filters__line__see-more Filters__line--icon Filters__line--icon--right Filters__line--right"
        >
          {this.props.text ? this.props.text : 'Ver mais'}
        </div>
      )
    }
    return ''
  }

  renderClosedState() {
    if (this.props.compact) {
      return (
        <FilterGroup>
          <div
            onClick={this.handleOpen.bind(this, true)}
            className="Filters__line Filters__line--compact Filters__line--icon Filters__line--icon--right"
          >
            {this.renderText()}
          </div>
        </FilterGroup>
      )
    }
    return (
      <Fragment>
        {this.renderList(
          this.props.limit ? this.props.limit : 4,
          'closed',
          true
        )}
      </Fragment>
    )
  }

  renderText() {
    return this.props.text ? this.props.text : 'Ver tudo'
  }

  renderSource() {
    if (
      (this.props.filtersSource && this.props.filtersSource.length) ||
      this.state.filters[this.props.vehicleType].length
    )
      return this.renderClosedState()
    return (
      <FilterGroup title={this.props.title}>
        {this.props.emptyText ? (
          this.props.emptyText
        ) : (
          <div className="Filters__no-filter">
            Nenhuma opção disponível para os fitros selecionados
          </div>
        )}
      </FilterGroup>
    )
  }

  render() {
    if (
      this.props.filterGroupName &&
      (this.props.vehicleType == 'car' || this.props.vehicleType == 'bike')
    ) {
      return (
        <Fragment>
          {this.renderSource()}
          {this.renderSlide()}
        </Fragment>
      )
    }
    return <span />
  }
}

export default withCookieNotice(DynamicFilterGroup)
